import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";

import { useStyles } from "../../../../Component/CSS/SearchFilterStyle.css";
import { url } from "../../../../config/config";

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      genreSet: [],
    };
  }

  componentDidMount() {
    this.getGenreData();
  }

  getGenreData = async () => {
    const response = await Axios.get(`${url}/api/categories`);
    if (response.data.length !== 0) {
      this.setState({ genreSet: response.data });
    } else {
      this.setState({ genreSet: [] });
    }
  };

  render() {
    const { classes, data, handleChange } = this.props;
    return (
      <div>
        <div style={{ fontSize: 16 }}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="title"
            type="text"
            label="Title"
            margin="normal"
            variant="outlined"
            fullWidth
            placeholder="Search by Title"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            style={{ marginRight: 10 }}
            value={data.title}
            onChange={handleChange}
          />
          <TextField
            name="authorFirstName"
            type="text"
            label="Author's FirstName"
            margin="normal"
            variant="outlined"
            fullWidth
            placeholder="Search by author"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            style={{ marginRight: 10 }}
            value={data.authorFistName}
            onChange={handleChange}
          />
          <TextField
            name="authorLastName"
            type="text"
            label="Author's LastName"
            margin="normal"
            variant="outlined"
            fullWidth
            placeholder="Search by author"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            style={{ marginRight: 10 }}
            value={data.authorLastName}
            onChange={handleChange}
          />
          <TextField
            name="genre"
            label="genre"
            margin="normal"
            variant="outlined"
            fullWidth
            select
            SelectProps={{
              native: true,
            }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            style={{ marginRight: 10 }}
            value={data.genre}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            <optgroup label="Genre">
              {this.state.genreSet.map((genre, index) => (
                <option key={index} value={genre.label}>
                  {genre.label}
                </option>
              ))}
            </optgroup>
          </TextField>
          <TextField
            name="publishedDate"
            type="date"
            label="Pubished Date"
            margin="normal"
            variant="outlined"
            fullWidth
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.publishedDate}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchForm);
